import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { NgbAlertConfig } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'app/utils/alert.service';
import 'rxjs/add/operator/debounceTime';

/**
 * @author Wesley Mascarenhas
 * @version $Id: alert.component.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
@Component({
  selector: 'app-alert',
  templateUrl: './alert.template.html',
  providers: [ NgbAlertConfig ]
})
export class NgbAlert implements OnInit {

  private subject = new Subject<string>();
  private messageValue: string = null;
  private type: string;
  private alertSubscription: any = null;

  constructor(private alertConfig: NgbAlertConfig, private alertService: AlertService) {

  }

  ngOnInit(): void {
    this.alertConfig.type = 'success';
    this.type = this.alertConfig.type;
    this.alertSubscription = this.alertService.alertMessage.subscribe(
      msg => {
        this.alertConfig.type = msg['type'];
        this.type = this.alertConfig.type;
        this.setMessage(msg['message']);
      }
    );
    this.subject.subscribe(
      message => {
        this.messageValue = message;
      }
    );
    this.subject.debounceTime(5000).subscribe(() => this.messageValue = null);
  }

  setMessage(message: string) {
    this.subject.next(message);
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/alert.component.ts